
import React from 'react';
import { Button } from "@/components/ui/button";
import { Plus, Minus, RotateCcw } from "lucide-react";

interface TeamScoreControlProps {
  teamName: string;
  score: number;
  onScoreChange: (score: number) => void;
}

export function TeamScoreControl({ teamName, score, onScoreChange }: TeamScoreControlProps) {
  return (
    <div className="bg-[#1A1F2C]/80 rounded-lg p-4 backdrop-blur-sm border border-white/10">
      <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-white mb-3">{teamName}</h3>
      <div className="flex items-center gap-2">
        <Button 
          onClick={() => onScoreChange(Math.max(0, score - 1))} 
          variant="outline"
          size="icon"
          className="flex-1 border-white/20 h-10"
        >
          <Minus className="h-4 w-4" />
        </Button>
        <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white w-16 text-center">
          {score}
        </div>
        <Button 
          onClick={() => onScoreChange(Math.min(99, score + 1))} 
          variant="outline"
          size="icon"
          className="flex-1 border-white/20 h-10"
        >
          <Plus className="h-4 w-4" />
        </Button>
        <Button 
          onClick={() => onScoreChange(0)} 
          variant="outline"
          size="icon"
          className="border-white/20 hover:bg-[#ea384c]/10 hover:text-[#ea384c] hover:border-[#ea384c] h-10"
        >
          <RotateCcw className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
